var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.318,
    height: 55.318,
    viewBox: "0 0 55.318 55.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9679",
    "data-name": "Group 9679",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M5282.766,3203.024a12.655,12.655,0,0,0-12.615,11.359,11.648,11.648,0,0,0-.064,1.221,12.46,12.46,0,0,0,2.413,7.378l-1.579,4.674,4.871-1.553a12.69,12.69,0,0,0,19.655-10.5c0-.332-.015-.656-.042-.981A12.656,12.656,0,0,0,5282.766,3203.024Zm7.4,17.769a3.681,3.681,0,0,1-2.491,1.744c-.677.064-.677.551-4.439-.912s-6.13-5.3-6.314-5.542a8.409,8.409,0,0,1-1.319-2.54,4.761,4.761,0,0,1-.191-1.251,4.11,4.11,0,0,1,1.292-3.064,1.369,1.369,0,0,1,.99-.458c.247,0,.493.036.707.036s.528-.127.832.606,1.05,2.542,1.144,2.725a.66.66,0,0,1,.028.643,4.614,4.614,0,0,1-.233.437c-.042.056-.083.113-.133.177-.19.213-.388.474-.557.642-.183.185-.375.382-.163.75a10.911,10.911,0,0,0,2.055,2.534,9.994,9.994,0,0,0,2.972,1.822c.372.184.585.156.8-.092s.926-1.065,1.171-1.433.5-.311.835-.183,2.151,1.008,2.527,1.193.612.276.706.423A3.032,3.032,0,0,1,5290.164,3220.793Z",
    transform: "translate(-5254.727 -3189.598)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M5272.565,3181a27.659,27.659,0,1,0,27.658,27.658A27.657,27.657,0,0,0,5272.565,3181Zm.365,41.652a15.7,15.7,0,0,1-7.586-1.941l-8.7,2.765,2.83-8.361a15.461,15.461,0,0,1-2.249-8.051c0-.229.007-.456.014-.683a15.711,15.711,0,0,1,31.393.287c0,.132,0,.263,0,.4A15.645,15.645,0,0,1,5272.93,3222.652Z",
    transform: "translate(-5244.906 -3181)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.736caf826a553fb0cf1e375a09ebeec5.svg";
export { ForwardRef as ReactComponent };